/**
 * CSV Formatting Utilities for Monitoring Data Export
 */

import { stringifyUnknownValue } from "@/utils/stringifyUnknownValue"

/**
 * Escapes a value for CSV format with proper JSON string handling
 */
export function escapeCsvValue(value: unknown): string {
  if (value === null || value === undefined) {
    return ""
  }

  // Convert to string
  let stringValue =
    typeof value === "string" ? value : stringifyUnknownValue(value)

  // Check for CSV injection vulnerabilities
  // Values starting with =, +, -, @, tab, or carriage return can be interpreted as formulas
  const csvInjectionPattern = /^[=+\-@\t\r]/
  if (csvInjectionPattern.test(stringValue)) {
    // Prefix with single quote to force text interpretation in spreadsheet software
    const escapedValue = `'${stringValue}`

    // If the value contains comma, newline, carriage return, or quote, wrap in quotes and escape internal quotes
    if (
      escapedValue.includes(",") ||
      escapedValue.includes("\n") ||
      escapedValue.includes("\r") ||
      escapedValue.includes('"')
    ) {
      // Escape existing quotes by doubling them
      const doubleEscapedValue = escapedValue.replace(/"/g, '""')
      // Wrap in quotes
      return `"${doubleEscapedValue}"`
    }

    return escapedValue
  }

  // If value contains comma, newline, carriage return, or quote, wrap in quotes and escape internal quotes
  if (
    stringValue.includes(",") ||
    stringValue.includes("\n") ||
    stringValue.includes("\r") ||
    stringValue.includes('"')
  ) {
    // Escape existing quotes by doubling them
    stringValue = stringValue.replace(/"/g, '""')
    // Wrap in quotes
    return `"${stringValue}"`
  }

  return stringValue
}
